import React, { useState } from "react";
import "./AnimalSound.css";

const easyAnimals = [
  { emoji: "🐶", name: "Dog", sound: "/sounds/dog.mp3" },
  { emoji: "🐱", name: "Cat", sound: "/sounds/cat.mp3" },
  { emoji: "🐮", name: "Cow", sound: "/sounds/cow.mp3" },
    { emoji: "🐝", name: "Bee", sound: "/sounds/bee.mp3" },
      { emoji: "🐔", name: "Chicken", sound: "/sounds/chicken.mp3" },
        { emoji: "🦅", name: "Eagle", sound: "/sounds/eagle.mp3" },
  { emoji: "🐸", name: "Frog", sound: "/sounds/frog.mp3" },
  { emoji: "🐴", name: "Horse", sound: "/sounds/horse.mp3" },
  { emoji: "🐈", name: "Kitten", sound: "/sounds/cat.mp3" },
    { emoji: "🐠", name: "Tropical Fish", sound: "/sounds/fishsl.mp3" },
      { emoji: "🦜", name: "Parrot", sound: "/sounds/parrot.mp3" },
  { emoji: "🦚", name: "Peacock", sound: "/sounds/peacock.mp3" },
    { emoji: "🦆", name: "Duck", sound: "/sounds/duck.mp3" },


  { emoji: "🐷", name: "Pig", sound: "/sounds/pig.mp3" },
  { emoji: "🦎", name: "Lizard", sound: "/sounds/lizard.mp3" },

  { emoji: "🐑", name: "Sheep", sound: "/sounds/sheep.mp3" },
  { emoji: "🐇", name: "Rabbit", sound: "/sounds/rabbit.mp3" },
  { emoji: "🐃", name: "Buffalo", sound: "/sounds/buffalo.mp3" },
  { emoji: "🐒", name: "Monkey", sound: "/sounds/monkey.mp3" },


  { emoji: "🐦", name: "Bird", sound: "/sounds/bird.mp3" }
];

const hardAnimals = [
  { emoji: "🦁", name: "Lion", sound: "/sounds/lion.mp3" },
  { emoji: "🐘", name: "Elephant", sound: "/sounds/elephant.mp3" },
  { emoji: "🦉", name: "Owl", sound: "/sounds/owl.mp3" },
    { emoji: "🐆", name: "Leopard", sound: "/sounds/lepord.mp3" },
      { emoji: "🦧", name: "Ape", sound: "/sounds/ape.mp3" },
        { emoji: "🦩", name: "Flamingo", sound: "/sounds/flamingos.mp3" },
          { emoji: "🦏", name: "Rhinoceros", sound: "/sounds/rhino.mp3" },
  { emoji: "🐿️", name: "Squirrel", sound: "/sounds/squirrel.mp3" },
    { emoji: "🦢", name: "Swan", sound: "/sounds/swan.mp3" },
  { emoji: "🦃", name: "Turkey", sound: "/sounds/turkey.mp3" },

  { emoji: "🐊", name: "Crocodile", sound: "/sounds/crocodile.mp3" },
  { emoji: "🐧", name: "Penguin", sound: "/sounds/penguin.mp3" },


        { emoji: "🐬", name: "Dolphin", sound: "/sounds/dolphin.mp3" },

        { emoji: "🐳", name: "Whale", sound: "/sounds/whale.mp3" },
  { emoji: "🦡", name: "Badger", sound: "/sounds/badger.mp3" },
    { emoji: "🐕", name: "Hound", sound: "/sounds/hound.mp3" },


  { emoji: "🦈", name: "Shark", sound: "/sounds/shark.mp3" },



  { emoji: "🐍", name: "Snake", sound: "/sounds/snake.mp3" }
];

export default function AnimalSound() {
  const [difficulty, setDifficulty] = useState("easy");
  const [score, setScore] = useState(0);
  const [message, setMessage] = useState("");
  const [currentAnimal, setCurrentAnimal] = useState(null);

  const animals = difficulty === "easy" ? easyAnimals : hardAnimals;

  // Feedback sounds
  const correctSound = new Audio("/sounds/correct.mp3");
  const wrongSound = new Audio("/sounds/wrong.wav");
  const winSound = new Audio("/sounds/win.mp3");

  const playAnimalSound = (animal) => {
    const audio = new Audio(animal.sound);
    audio.play();
    setCurrentAnimal(animal);
    setMessage("🔊 Listen carefully...");
  };

  const checkAnswer = (choice) => {
    if (currentAnimal && choice === currentAnimal.name) {
      setScore(score + 10);
      setMessage("✅ Correct! It was " + currentAnimal.name);
      correctSound.play();
      if (score + 10 >= 40) {
        setMessage("🎉 You win! Final Score: " + (score + 10));
        winSound.play();
      }
    } else {
      setScore(score - 5);
      setMessage("❌ Wrong, try again!");
      wrongSound.play();
    }
  };

  return (
    <div className="animal-container">
      <h1>🐾 Animal Sounds Quiz</h1>
      <div className="mode-buttons">
        <button onClick={() => {setDifficulty("easy"); setScore(0);}}>Easy</button>
        <button onClick={() => {setDifficulty("hard"); setScore(0);}}>Hard</button>
      </div>
      <p>⭐ Score: {score}</p>
      <p className="status">{message}</p>

      <div className="emoji-grid">
        {animals.map((animal, index) => (
          <button
            key={index}
            className="emoji-btn"
            onClick={() => playAnimalSound(animal)}
          >
            {animal.emoji}
          </button>
        ))}
      </div>

      <div className="choices-grid">
        {animals.map((animal, index) => (
          <button
            key={index}
            className="choice-btn"
            onClick={() => checkAnswer(animal.name)}
          >
            {animal.name}
          </button>
        ))}
      </div>
    </div>
  );
}


